<template>
<div class="container">
  <div class="formulario">
    <div class="titulo">
      <h2>{{ titulo }}</h2>
    </div>
    <validation-observer ref="observer">

      <b-form  @submit.stop.prevent="submit">

        <div class="dadosTitular">

          <b-alert class="negrito" show>
            <b-icon icon="person-lines-fill" class="mr-1" /> Dados do Titular
          </b-alert>
<!--
          <b-form-group id="">
            <b-form-checkbox-group v-model="form.possuiCPF" id="possuiCPF">
              <b-form-checkbox value="1" @change="habilitaDesabilitaCPF()">Não possui CPF.</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
-->          
          <div class="row">

            <b-form-group id="cpf-group" label="CPF *" label-for="cpf" class="col-md-6 col-sm-12"  v-if="!form.possuiCPF.length">
              <validation-provider name="CPF" rules="required|numeric|valida_cpf|" v-slot="validationContext">
                <b-form-input v-model="form.cpf" type="text" name="cpf" :disabled="disabled" :state="getValidationState(validationContext)"></b-form-input>
                <b-form-invalid-feedback id="input-cpf-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>

            <b-form-group id="dataNascimento-group" label="Data de nascimento  *" label-for="dataNascimento" class="col-md-6 col-sm-12">
              <validation-provider name="Data de nascimento" rules="required|max:10" v-slot="validationContext">
                <b-form-input id="dataNascimento" v-model="form.dataNascimento" type="date" name="dataNascimento" :state="getValidationState(validationContext)"></b-form-input>
                <b-form-invalid-feedback id="input-data-nascimento-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </div>
          <div v-if="form.possuiCPF.length">
            <div>
              <b-form-group id="" label="Justificativa  *" label-for="justificativaAusenciaCPF">
                <validation-provider name="Justificativa" rules="required|alpha_spaces|max:1024" v-slot="validationContext">
                  <b-form-input id="justificativaDocumento" v-model="form.justificativaAusenciaCPF" type="text" data-tipo="justificativaAusenciaCPF" :state="getValidationState(validationContext)"></b-form-input>
                  <b-form-invalid-feedback id="input-justificativa-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </div>
            <div class="row">
              <b-form-group label="Documento *" label-for="tipoDocumento" class="col-md-6 col-sm-12">
                <validation-provider name="Documento" rules="required|max:50" v-slot="validationContext">
                  <b-form-input id="tipoDocumento" v-model="form.tipoDocumento" type="text" :state="getValidationState(validationContext)"></b-form-input>
                  <b-form-invalid-feedback id="input-documento-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Número Documento  *" label-for="numeroDocumento" class="col-md-6 col-sm-12">
                <validation-provider name="Número Documento" rules="required|max:50" v-slot="validationContext">
                  <b-form-input id="numeroDocumento" v-model="form.numeroDocumento" type="text" :state="getValidationState(validationContext)"></b-form-input>
                  <b-form-invalid-feedback id="input-numero-documento-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </div>
          </div>
          <b-form-group id="nome" label="Nome *" label-for="nome">
            <validation-provider name="Nome" rules="required|alpha_spaces|max:255" v-slot="validationContext">
              <b-form-input id="nome" v-model="form.nome" type="text" data-tipo="nome" :state="getValidationState(validationContext)"></b-form-input>
              <b-form-invalid-feedback id="input-nome-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>
          <div class="row">
            <b-form-group label="Telefone principal" label-for="telefonePrincipal" class="col-md-6 col-sm-12">
              <validation-provider name="Telefone principal" rules="max:20|numeric" v-slot="validationContext">
              <b-form-input id="telefonePrincipal" v-model="form.telefonePrincipal" type="text" placeholder=""  :state="getValidationState(validationContext)"></b-form-input>
              <b-form-invalid-feedback id="input-telefonePrincipal-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Telefone adicional" label-for="telefoneAdicional1" class="col-md-6 col-sm-12">
              <validation-provider name="Telefone adicional" rules="max:20|numeric" v-slot="validationContext">
              <b-form-input id="telefoneAdicional1" v-model="form.telefoneAdicional" type="text" placeholder="" :state="getValidationState(validationContext)"></b-form-input>
              <b-form-invalid-feedback id="input-telefoneAdicional1-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>

          </div>
          <b-form-group label="Email *" label-for="email">
            <validation-provider name="Email" rules="required|email|max:200" v-slot="validationContext">
              <b-form-input id="email" v-model="form.email" type="text" :state="getValidationState(validationContext)"></b-form-input>
              <b-form-invalid-feedback id="input-email-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>
          <div class="row">
            <b-form-group label="País *" label-for="pais" class="col-md-4 col-sm-12">
              <validation-provider name="Pais" rules="required" v-slot="validationContext">
                <b-form-select id="pais" v-model="form.paisSelecionado" :state="getValidationState(validationContext)" @change="getEstados(form.paisSelecionado),limpaDadosEndereco()">
                  <option value="">Selecione</option>
                  <option v-for="pais in paises" :value="pais.codigo">
                    {{ pais.descricao }}
                  </option>
                </b-form-select>
                <b-form-invalid-feedback id="input-pais-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </div>

          <div v-if="form.paisSelecionado === 1">
            <div class="row">
              <b-form-group label="UF *" label-for="uf" class="col-md-4 col-sm-12">
                <validation-provider name="UF" rules="required" v-slot="validationContext">
                  <b-form-select id="uf" v-model="form.ufSelecionada" :state="getValidationState(validationContext)" @change="getMunicipios(form.ufSelecionada)">
                    <option value="">Selecione</option>
                    <option v-for="estado in estados" :value="estado.codigo">
                      {{ estado.descricao }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input-uf-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Município *" label-for="municipio" class="col-md-4 col-sm-12">
                <validation-provider name="Município" rules="required" v-slot="validationContext">
                  <b-form-select id="municipio" v-model="form.municipioSelecionado" :state="getValidationState(validationContext)">
                    <option value="">Selecione</option>
                    <option v-for="municipio in municipios" :value="municipio.codigo">
                      {{ municipio.descricao }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input-municipio-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
              <b-form-group label="CEP" label-for="cep" class="col-md-4 col-sm-12">
                <validation-provider name="CEP" rules="digits:8" v-slot="validationContext">
                  <b-form-input id="cep" v-model="form.cep" type="text" :state="getValidationState(validationContext)"></b-form-input>
                  <b-form-invalid-feedback id="input-cep-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </div>

            <div class="row">
              <b-form-group label="Endereço" label-for="endereco" class="col-md-8 col-sm-12">
                <validation-provider name="Endereço" :rules="{ max:500,regex:/^[a-z0-9-\u00C0-\u00FF\,\.\s]*$/i }" v-slot="validationContext">
                  <b-form-input id="endereco" v-model="form.endereco" type="text" max="500" :state="getValidationState(validationContext)"></b-form-input>
                  <b-form-invalid-feedback id="input-endereco-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Bairro" label-for="bairro" class="col-md-4 col-sm-12">
                <validation-provider name="Bairro" rules="max:50" v-slot="validationContext">
                  <b-form-input id="bairro" v-model="form.bairro" type="text" :state="getValidationState(validationContext)"></b-form-input>
                  <b-form-invalid-feedback id="input-bairro-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </div>
          </div>
        </div>

        <div class="dadosSolicitacao">

          <b-alert class="negrito" show>
            <b-icon icon="file-text" class="mr-1" /> Dados do Requerimento
          </b-alert>

          <b-form-group label="Tipo de Requerimento *" label-for="tipoSolicitacao" class="col-md-8 col-sm-12">
            <validation-provider name="Tipo de Requerimento" rules="required" v-slot="validationContext">
              <b-form-checkbox v-for="tipoSolicitacao in tipoSolicitacoes" v-model="form.tipoSolicitacaoSelecionada" name="tipoSolicitacao" :key="tipoSolicitacao.codigo" :value="tipoSolicitacao.codigo" :state="getValidationState(validationContext)"
                stacked>
                {{ tipoSolicitacao.descricao}}
              </b-form-checkbox>
              <b-form-invalid-feedback id="input-tipo-solicitacao-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>

          <b-form-group label="Descrição do Requerimento *" label-for="descricaoSolicitacao">
             <validation-provider name="Descrição do Requerimento" rules="max:2000|required|valida_descricao" v-slot="validationContext"> 
              <b-form-textarea id="descricaoSolicitacao" v-model="form.descricaoSolicitacao" rows="3"
                name="descricaoSolicitacao" :state="getValidationState(validationContext)"></b-form-textarea>
              <b-form-invalid-feedback id="input-descricao-solicitacao-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>

           <div v-if="listaArquivosAnexo.length">
            <b-list-group>
              <b-list-group-item v-for="(arquivo, index) in listaArquivosAnexo" v-bind:key="index" class="d-flex justify-content-between align-items-center">
                <span>
                  <b-icon-paperclip />{{ arquivo.name }} ({{ formataTamanhoAnexo(arquivo.size) }})
                </span>
                <b-icon-trash-fill variant="danger" @click="removeAnexoDaLista(index)" />
              </b-list-group-item>
              <b-list-group-item>
                Remover todos os {{ listaArquivosAnexo.length }} anexos ({{ formataTamanhoAnexo(calculaTamanhoAnexos()) }})
                <b-icon-trash-fill variant="danger" @click="removeTodosAnexos()" /><br>
                <strong>Tamanho máximo total: 4MB</strong>
              </b-list-group-item>
            </b-list-group>
          </div>
          <vue-recaptcha
            ref="recaptcha"
            sitekey="6LcFQ9ohAAAAANm-_g2_YHW3ZTFjxt24oZc-n5G8"
            theme="light"
            @verify="enviaRequerimento"
            size="invisible"
          > </vue-recaptcha>

          <!-- 6LcFQ9ohAAAAANm-_g2_YHW3ZTFjxt24oZc-n5G8  sitekey para mpt.mp.br v3 -->
          <!-- 6LeupMMhAAAAALkfXZQ7isrox5l75rGzytXytSUO  sitekey para localhost v3 -->
          <!-- 6LcxnKUhAAAAAFxT2g7YfeGP5zq3fnpYYfG0F2Dx  sitekey para localhost   -->
          <!-- 6Ld30qkhAAAAAIVdOaEIwRKuk1udIqei5rgYif06  sitekey para mpt.mp.br   -->
          <div class="titulo">
            <b-button type="submit" variant="primary">Cadastrar</b-button>
            <b-button variant="secondary" @click="resetForm">Limpar Formulário</b-button>
          </div>
        </div>
      </b-form>
    </validation-observer>
  </div>
  <b-modal
    id="modal-alerta-lgpd"
    centered
    ok-only
    ok-variant="light"
    ok-title="Ciente"
    title="Lei Geral de Proteção de Dados Pessoais"
  >
      <div class="" style="white-space: normal;">
        <p>Para o exercício dos direitos previstos no Art. 18 da Lei Geral de Proteção de Dados (Lei 13.709/2018), o titular dos dados deve encaminhar requerimento através deste formulário.</p>
        Para processar as solicitações dos usuários, o MPT coleta e armazena os seguintes dados:
        <ul>
          <li>Endereço IP;</li>
          <li>Dados pessoais fornecidos no preenchimento do formulário de manifestações: nome, documento de identificação, idade, e-mail, país e a descrição do requerimento.</li>
        </ul>
      </div>
  </b-modal>

</div>
</template>

<script>
import api from '../api';
import { VueRecaptcha } from 'vue-recaptcha';
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import {
  required,
  email,
  numeric,
  alpha_spaces,
  max,
  max_value,
  digits,
  ext,
  regex,
} from 'vee-validate/dist/rules';

localize("pt_BR", pt_BR);
extend('email', email);
extend('required', required);
extend('numeric', numeric);
extend('alpha_spaces', alpha_spaces);
extend('max', max);
extend('max_value', max_value);
extend('digits', digits);
extend('ext', ext);
extend('regex', regex);

const valida_descricao = {
  validate(value, args) {
    let textoDescricao = value;
    let pattern = /^[a-z0-9-\u00C0-\u00FF\,\.\;\:\_\@\s]*$/i
    if(pattern.exec(textoDescricao)) {
      return true
    }
    return "A Descrição do Requerimento só pode conter letras, números, espaços e os caracteres  . , : ; - _ @";
  }
}
extend('valida_descricao', valida_descricao);

const valida_cpf = {
  validate(value, args) {

    let strCPF = value;
    let Soma = 0;
    let Resto;
    let msg = "CPF inválido";

    if (strCPF.length !== 11)
       return msg;

    if ([
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
      ].indexOf(strCPF) !== -1){
      return msg;
    }

    for (let i = 1; i <= 9; i++){
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i)
    }
    Resto = (Soma * 10) % 11

    if ((Resto == 10) || (Resto == 11))
      Resto = 0;

    if (Resto != parseInt(strCPF.substring(9, 10)))
      return msg;

    Soma = 0;
    for (let i = 1; i <= 10; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))
      Resto = 0;

    if (Resto != parseInt(strCPF.substring(10, 11)))
      return msg;
    return true;
  }

};

extend('valida_cpf', valida_cpf);

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha
  },
  data() {
    return {
      titulo: 'Requerimento LGPD - MPT',
      form: {
        possuiCPF: [],
        cpf: '',
        dataNascimento: '',
        justificativaAusenciaCPF: '',
        tipoDocumento: '',
        numeroDocumento: '',
        nome: '',
        telefonePrincipal: '',
        telefoneAdicional: '',
        email: '',
        paisSelecionado: '',
        ufSelecionada: '',
        municipioSelecionado: '',
        cep: '',
        endereco: '',
        bairro: '',
        tipoSolicitacaoSelecionada: [],
        descricaoSolicitacao: '',
        arquivos: [],
      },
      paises: {},
      estados: {},
      municipios: {},
      tipoSolicitacoes: {},
      disabled: false,
      showEndereco: false,
      formJson: {},
      formData: {},
      listaArquivosAnexo: [],
      tamanhoArquivos: 0,
      arquivos2: []
    }

  },

  created() {
    this.getPaises()
    this.getTiposSolicitacao()
  },

  mounted() {
    this.modalAlerta()
  },

  computed: {

  },

  methods: {

    modalAlerta() {
      this.$bvModal.show('modal-alerta-lgpd')
    },

    getPaises() {
      api
        .get('/paises')
        .then(res => {
          this.paises = res.data
        })

    },

    getTiposSolicitacao() {
      api
        .get('/tiposolicitacoes')
        .then(res => this.tipoSolicitacoes = res.data)
    },

    getValidationState({
      dirty,
      validated,
      valid = null
    }) {
      return dirty || validated ? valid : null;
    },

    validaAnexo(v) {
       if(v.dirty || v.validated) {
        return v.valid
       } else {
        return null
       }
    },

    listaAnexos2(event) {
      this.validate(anexos2, 'ext:pdf,png', {
        name: 'Anexos2'
      })
        .then(result => {
          if (result.valid) {
          } else {
          }
        })
    },

    listaAnexos(event) {
      for (let file of event.target.files) {
        this.listaArquivosAnexo.push(file)
        //this.$refs['arquivos'].reset()
      }
    },

    formataTamanhoAnexo(tamanho) {
      return (tamanho > 1048576) ? (tamanho / 1048576).toFixed(2) + ' MB' : (tamanho / 1024).toFixed(2) + ' KB'
    },

    calculaTamanhoAnexos() {
      let tamanhoAnexos = 0
      for (let arquivo of this.listaArquivosAnexo) {
        tamanhoAnexos = tamanhoAnexos + arquivo.size
      }
      //return this.formataTamanhoAnexo(tamanhoAnexos)
      this.tamanhoArquivos = tamanhoAnexos
      return tamanhoAnexos
    },

    removeAnexoDaLista(index) {
      this.listaArquivosAnexo.splice(index, 1)
      this.$refs['arquivos'].reset()
    },

    removeTodosAnexos() {
      this.listaArquivosAnexo.splice(0, this.listaArquivosAnexo.length)
      this.$refs['arquivos'].reset()
    },

    resetForm() {
      this.form.cpf = this.form.dataNascimento = this.form.justificativaAusenciaCPF = this.form.tipoDocumento = this.form.numeroDocumento = this.form.nome = this.form.telefonePrincipal = this.form.telefoneAdicional = this.form.email = this.form.paisSelecionado = this.form.ufSelecionada = this.form.municipioSelecionado = this.form.cep = this.form.endereco = this.form.bairro = this.form.descricaoSolicitacao = ''
      this.form.possuiCPF.length = this.form.tipoSolicitacaoSelecionada.length =  this.form.arquivos.length = 0
      const solicitacoes = document.getElementsByName('tipoSolicitacao')
      solicitacoes.forEach(item => {
        item.checked = false
      })
      //this.removeTodosAnexos()
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },

    submit() {
      this.$refs.recaptcha.execute()
    },

    enviaRequerimento(response){
     
      this.$refs.observer.validate().then(success => {

        if (!success) {
          return;
        }
        this.formJson.possuiCPF = this.form.possuiCPF,
        this.formJson.cpf = this.form.cpf,
        this.formJson.dataNascimento = this.form.dataNascimento,
        this.formJson.justificativaAusenciaCPF = this.form.justificativaAusenciaCPF,
        this.formJson.tipoDocumento = this.form.tipoDocumento,
        this.formJson.numeroDocumento = this.form.numeroDocumento,
        this.formJson.nomeSolicitante = this.form.nome,
        this.formJson.telefonePrincipal = this.form.telefonePrincipal,
        this.formJson.telefoneAdicional = this.form.telefoneAdicional,
        this.formJson.email = this.form.email,
        this.formJson.pais = this.form.paisSelecionado,
        this.formJson.uf = this.form.ufSelecionada,
        this.formJson.municipio = this.form.municipioSelecionado,
        this.formJson.cep = this.form.cep,
        this.formJson.endereco = this.form.endereco,
        this.formJson.bairro = this.form.bairro,
        this.formJson.tipoSolicitacao = this.form.tipoSolicitacaoSelecionada,
        this.formJson.descricaoSolicitacao = this.form.descricaoSolicitacao,
        this.formJson.ip = '10.0.0.0',

        this.formData = new FormData()
/*
        for (let file of this.listaArquivosAnexo) {
          this.formData.append('arquivos', file)
        }
*/
        this.formData.append('dados', JSON.stringify(this.formJson))

        api
          .post("/solicitacoes", this.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
               "x-access-token": response,
            },
          })
          .then(res => {
              if (res.status === 201) {
                const numeroSolicitacao = res.data
                this.resetForm()
                this.$bvModal.msgBoxOk('- Enviamos um e-mail, para o endereço informado, com um link para confirmar seu requerimento. \n\n- Você precisa confirmá-lo para dá andamento a solicitação.', {
                  title: 'Ação necessária',
                  size: 'sm',
                  buttonSize: 'sm',
                  headerClass: 'p-2 border-bottom-0',
                  footerClass: 'p-2 border-top-0',
                  centered: true
                })
              }
            },
            err => {
            this.$bvModal.msgBoxOk('❌Erro na aplicação ', {
                title: 'Falha no envio do Requerimento. Favor tentar o envio do formulário mais tarde',
                size: 'sm',
                buttonSize: 'sm',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
              })
            }) 
      })
      .catch(()=> {
        console.log("falhou")
      })
    },

    getEstados(pais) {
      if (pais === 1) {
        api
          .get("/estados/")
          .then(res => this.estados = res.data)

      } else {
        this.form.municipioSelecionado = ''
      }
      this.form.municipioSelecionado = ''
    },

    getMunicipios(estado) {
      if (estado != '') {
        api
          .get("/municipios/" + estado)
          .then(res => this.municipios = res.data)
      } else {
        this.municipios = null
      }
    },

    habilitaDesabilitaCPF() {
      this.disabled = !this.disabled
      this.form.cpf = ''
      this.form.justificativaAusenciaCPF = ''
      this.form.tipoDocumento = ''
      this.form.numeroDocumento = ''                  
    },

    limpaDadosEndereco() {
      this.form.ufSelecionada= '',
      this.form.municipioSelecionado = ''
      this.form.cep = ''
      this.form.endereco = ''
      this.form.bairro = ''
    },

  }
}
</script>

<style>
.formulario {
  width: 80%;
  margin: auto;
  background-color: #f8f9fa !important;
}

.titulo {
  margin-top: 20px;
  margin-bottom: 6em;

}

label.d-block {
  font-weight: bold;
}

.container {
  margin: 0px;
  background-color: #f8f9fa !important;
}

.negrito {
  font-weight: bold;
}

.custom-file-input {
  /* opacity: 100; */
}

.custom-file-input:before {
  content: "Escolha o(s) arquivo(s)";
  display: flex;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 26%);
  color: #fff;
  background-color: #ff5722;
  position: relative;
  cursor: pointer;
  min-height: 36px;
  min-width: 88px;
  line-height: 36px;
  vertical-align: middle;
  align-items: center;
  text-align: center;
  border-radius: 2px;
  box-sizing: border-box;
  outline: none;
  border: 0;
  padding: 0 20px;
  /* margin: 6px 8px; */
  white-space: nowrap;
  text-transform: uppercase;
  /* font-weight: 500; */
  font-size: 14px;
  text-decoration: none;
  overflow: hidden;
}

.alert-info {
  background-color: transparent;
  border-color: transparent;
}

.alert {
  padding: 0px;
}

.dadosTitular {
  background-color: white;
  padding-top: 2em;
  padding-left: 2em;
  padding-right: 2em;
}

.dadosSolicitacao {
  background-color: white;
  margin-top: 2em;
  padding-top: 2em;
  padding-left: 2em;
  padding-right: 2em;
}
.oculto {
  display: none;
}

@media (max-width: 678px) {
  .titulo {
    margin-bottom: 0px;
  }

  .titulo h2{
    font-size: 1.5rem;
  }
}

.modal-body {
  white-space:break-spaces;
}


.modal-content {
  width: fit-content!important;
}

/*
.is-valid input, span {
  color: #045929;
}
.is-valid input {
  border: 1px #045929 solid;
}*/
/*
.is-invalid input, span {
  color: #dc3545;
}
.is-invalid input {
  border: 1px #dc3545 solid;
  box-shadow: 0 0 0 0.2rem rgb(220 53 69 / 25%);
}*/
</style>



// WEBPACK FOOTER //
// src/views/RequerimentoLGPD.vue